export default "<div class=\"w-50\">\n    <eec-login></eec-login>\n</div>\n"